// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchCategories_container__QIHr3"};